import {MaterialType} from "@generated"
import type {StateLabel} from "@labels"

export interface MaterialTypeLabel extends StateLabel<MaterialType> {
    type: MaterialType
    label: string
}

export const MaterialTypeLabels: Map<MaterialType, MaterialTypeLabel> = new Map<MaterialType, MaterialTypeLabel>([
    [MaterialType.Wood, {type: MaterialType.Wood, state: MaterialType.Wood, label: "Wood"}],
    [MaterialType.Metal, {type: MaterialType.Metal, state: MaterialType.Metal, label: "Metal"}],
    [MaterialType.Fabric, {type: MaterialType.Fabric, state: MaterialType.Fabric, label: "Fabric"}],
    [MaterialType.Leather, {type: MaterialType.Leather, state: MaterialType.Leather, label: "Leather"}],
    [MaterialType.Glass, {type: MaterialType.Glass, state: MaterialType.Glass, label: "Glass"}],
    [MaterialType.Ceramic, {type: MaterialType.Ceramic, state: MaterialType.Ceramic, label: "Ceramic"}],
    [MaterialType.Plastic, {type: MaterialType.Plastic, state: MaterialType.Plastic, label: "Plastic"}],
    [MaterialType.Paper, {type: MaterialType.Paper, state: MaterialType.Paper, label: "Paper"}],
    [MaterialType.Paint, {type: MaterialType.Paint, state: MaterialType.Paint, label: "Paint"}],
    [MaterialType.Wall, {type: MaterialType.Wall, state: MaterialType.Wall, label: "Wall"}],
    [MaterialType.Rubber, {type: MaterialType.Rubber, state: MaterialType.Rubber, label: "Rubber"}],
    [MaterialType.FloorTiles, {type: MaterialType.FloorTiles, state: MaterialType.FloorTiles, label: "Floor - Tiles"}],
    [MaterialType.FloorWooden, {type: MaterialType.FloorWooden, state: MaterialType.FloorWooden, label: "Floor - Wooden"}],
    [MaterialType.FloorOther, {type: MaterialType.FloorOther, state: MaterialType.FloorOther, label: "Floor - Other"}],
    [MaterialType.ConcreteAndAsphalt, {type: MaterialType.ConcreteAndAsphalt, state: MaterialType.ConcreteAndAsphalt, label: "Concrete and Asphalt"}],
    [MaterialType.StoneMarbleGranite, {type: MaterialType.StoneMarbleGranite, state: MaterialType.StoneMarbleGranite, label: "Stone / Marble / Granite"}],
    [MaterialType.OrganicAndVegetation, {type: MaterialType.OrganicAndVegetation, state: MaterialType.OrganicAndVegetation, label: "Organic and Vegetation"}],
    [MaterialType.Other, {type: MaterialType.Other, state: MaterialType.Other, label: "Other"}],
])
